import { pick } from 'lodash/fp';
import { Text } from 'zrender';
import { TextStyleProps } from 'zrender/src/graphic/Text';

import { wrapText } from './get-adopted-title-and-subtitle';

export function measureTextSize(text: string, style: TextStyleProps, maxWidth: number) {
    const canvasElement = document.getElementById('canvasFontSizer');

    const context = canvasElement?.getContext('2d');
    const wrappedText = wrapText(context, text, maxWidth, style);

    const txt = new Text({
        style: {
            text: wrappedText,
            ...style,
            ...(maxWidth && { width: maxWidth, overflow: 'break' }),
        },
    });

    return pick(['width', 'height'], txt.getBoundingRect());
}
